import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
import router from '../../router'
const apiModule = api.auth
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function getModel () {
  return {
    login: {
      data: 'login',
      title: 'Логин',
      value: null,
      type: null
    },
    password: {
      data: 'password',
      title: 'Пароль',
      value: null,
      type: null
    }
  }
};

const state = {
  model: getModel(),
  errMain: null,
  errors: {
    login: null,
    password: null
  }
}
const getters = {
  getModel (state) { return state.model },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain }
}
const mutations = {
  setParams (state, data) { state.model[data.param].value = data.value },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data }
}
const actions = {
  resetParams ({ state, commit }) {
    let model = state.model
    for (let param in model) {
      commit('setParams', { param: param, value: null })
    };
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    for (let err in errors) {
      commit('setErrors', { param: err, value: null })
    };
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  signOut () {
    localStorage.removeItem('jwtToken')
    localStorage.removeItem('role')
    router.replace('/signin')
  },
  async signIn ({ state, commit, dispatch }, data) {
    try {
      let dataNew = mapper.dataToRequest(data.data)
      if (!dataNew.login) commit('setErrors', { param: 'login', value: errorsStr.empty })
      if (!dataNew.password) commit('setErrors', { param: 'password', value: errorsStr.empty })
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (!isErr) {
        let result = await httpService.post(apiModule.common.signin, dataNew)
        if (result.data) {
          localStorage.setItem('jwtToken', result.data.jwtToken)
          localStorage.setItem('role', result.data.role)
          localStorage.setItem('id', result.data.id)
          dispatch('resetParams')
          router.replace('/stat')
          dispatch('resetAllErr')
        };
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
